import { Modal, Table } from "antd";
import React from "react";
import { useDispatch } from "react-redux";
import TranslateText from "../../TranslateText";
import "../../../../assets/style/modalStyle/getLog.scss";
import { useMemo } from "react";
import { useState } from "react";
import moment from "moment";

const ModalGetLog = ({
  open,
  setOpen,
  width = 785,
  title = "Lịch sử thay đổi",
  data,
}) => {
  const dispatch = useDispatch();
  const handleCancel = () => {
    dispatch(setOpen(false));
  };
  const [page, setPage] = useState(0);
  const dataSource = useMemo(() => {
    const result = data?.map((item, index) => {
      return {
        ...item,
        STT: index + 1,
        timeUpdate: moment(item.timeUpdate).format("DD/MM/YYYY HH:mm:ss"),
        key: item.id,
      };
    });
    return result;
  }, [data]);
  const columns = [
    {
      title: "STT",
      dataIndex: "STT",
      key: "STT",
    },
    {
      title: <TranslateText text="Ngày thực hiện" />,
      dataIndex: "timeUpdate",
      key: "timeUpdate",
      className: "title",
    },
    {
      title: <TranslateText text="Người thực hiện" />,
      dataIndex: "userChange",
      key: "userChange",
    },
    {
      title: <TranslateText text="Nội dung thay đổi" />,
      dataIndex: "content",
      key: "content",
    },
  ];
  return (
    <>
      <Modal
        maskClosable={false}
        title={<TranslateText text={title} />}
        centered
        open={open}
        className="warrperModalGetLog"
        footer={[]}
        width={width}
        onCancel={handleCancel}
      >
        {dataSource?.length  ? (
          <div className="contentLog">
            <Table
              dataSource={dataSource}
              columns={columns}
              pagination={false}
            />
          </div>
        ) : (
          <p style={{ fontSize: 20 }}>Không có thông tin lịch sử chỉnh sửa</p>
        )}
      </Modal>
    </>
  );
};

export default ModalGetLog;
